import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

type DocumentsTableHeaderProps = {
  hasOptions: boolean;
};

const DocumentsTableHeader: FC<DocumentsTableHeaderProps> = ({
  hasOptions,
}) => {
  const { t } = useTranslate();

  return (
    <thead>
      <tr className="nk-tb-item tb-tnx-head">
        <th className="nk-tb-col">{t('Name')}</th>

        <th className="nk-tb-col">{t('Date')}</th>

        <th className="nk-tb-col text-right">{t('Doc')}</th>

        {hasOptions && <th className="nk-tb-col" />}
      </tr>
    </thead>
  );
};

export default DocumentsTableHeader;
